import "./MultiRoutePopup.css";

import {
  routeSelector,
  unallocatedVolumeSelector,
  volumesSinceLastReadyTimeSelector,
} from "../../reducers/matrixProfile/selectors";
import {
  selectedRouteSelector,
  selectedTimeBandSelector,
} from "../../reducers/ownApp/selectors";
import { zoomLevelSelector } from "../../reducers/map/selectors";

import { MapLocationIcon, ParcelIcon } from "../Icons";
import { RouteLabel } from "../Layers/RouteLabelLayer/RouteLabel";
import { View } from "../View";
import { getRouteVolume } from "../../utils/routes";
import { makeStyles } from "@mui/styles";
import { memo } from "react";
import { palette } from "../../theme/palette";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  container: {
    margin: "5px 0 5px 0",
    display: "flex",
    alignItems: "center",
  },
  routeLabelContainer: {
    backgroundColor: palette.typography.white.high,
    borderRadius: "2px",
    padding: "3px",
    display: "inline-block",
    marginRight: "5px",
  },
  mapLocationIcon: {
    width: "12px",
    height: "12px",
    fill: palette.typography.white.medium,
    marginLeft: "5px",
  },
  volumeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
    width: "45px",
  },
  volumeNumber: {
    marginLeft: "auto",
  },
});

export const MultiRoutePopupItem = memo(({ routeCode, postcode }) => {
  const styles = useStyles();
  const route = useSelector(routeSelector(routeCode));
  const volumes = useSelector(volumesSinceLastReadyTimeSelector);
  const zoomLevel = useSelector(zoomLevelSelector);
  const selectedRoute = useSelector(selectedRouteSelector);
  const selectedTimeBand = useSelector(selectedTimeBandSelector);
  const unallocatedVolume = useSelector(
    unallocatedVolumeSelector({ postcode, routeCode })
  );
  const volume = !!!routeCode
    ? unallocatedVolume
    : getRouteVolume({
        routeCode,
        route,
        postcode,
        volumes,
        zoomLevel,
        showAll: false,
        individual: true,
        selectedRoute,
        selectedTimeBand,
      });

  return (
    <View className={styles.container}>
      <View className={styles.routeLabelContainer}>
        <RouteLabel routeCode={routeCode} />
      </View>
      <View className={styles.volumeContainer}>
        <View className={styles.volumeNumber}>{volume?.stops || 0}</View>
        <MapLocationIcon className={styles.mapLocationIcon} />
      </View>
      <View className={styles.volumeContainer}>
        <View className={styles.volumeNumber}>{volume?.parcels || 0}</View>
        <ParcelIcon className={styles.mapLocationIcon} />
      </View>
    </View>
  );
});
